import axios from "axios"
import toast from "izitoast"

async function checkOrganizationRequiredContact(store) {
  const user = store.state.auth.user

  if (!user) {
    return true
  }

  // Se entrou com login da própria empresa (CNPJ), não bloqueia
  if (store.getters.isOrganization) {
    return true
  }

  // Só valida quando entrou com login de pessoa (CPF) vinculada a uma empresa
  const organizationId = store.state.auth.link?.organization_id

  if (!organizationId || Number(organizationId) === 0) {
    return true
  }

  try {
    await axios.get(
      `/api/registry/organization/${organizationId}/contacts/requirement`
    )
    return true
  } catch (e) {
    if (e.response?.status === 409) {
      toast.warning({
        message:
          e.response.data.error ||
          "É necessário informar ao menos um contato da empresa.",
      })
      return false
    }

    return true
  }
}

export default {
  install(_Vue, { store, router }) {
    axios.defaults.headers.common.Authorization = `${store.state.auth.type} ${store.state.auth.token}`

    if (store.state.auth.link !== null) {
      axios.defaults.headers.common["X-Link"] =
        `${store.state.auth.link.organization_id}`
    }

    router.beforeEach(async (to, _from, next) => {
      if (
        to.matched.some((record) => record.meta.forVisitors) &&
        store.state.auth.user !== null
      ) {
        return next({ name: "index" })
      }

      if (to.matched.some((record) => record.meta.forAuth)) {
        if (store.state.auth.user === null) {
          return next({ name: "login" })
        }

        const allowedRoutes = ["organization.edit"]

        if (!allowedRoutes.includes(to.name)) {
          const hasRequiredContact =
            await checkOrganizationRequiredContact(store)

          if (!hasRequiredContact) {
            return next({
              name: "organization.edit",
              query: { requiredContact: "1" },
            })
          }
        }
      }

      return next()
    })
  },
}
